<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormPersonal" role="form" method="post" autocomplete="off" onSubmit="return false">
					<div class="row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">Ver Contrato:</div>
					</div>

					<div class="row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-2">
							<div class="form-check">
								<input type="radio" v-model="ValorCheck" name="viewContrato" id="chkEs" value="1" class="form-check-input">
								<label class="form-check-label" for="chkEs">
									En Español
								</label>
							</div>
							
							</div>
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<div class="form-check">
								<input type="radio" v-model="ValorCheck" name="viewContrato" id="chkEn" value="2" class="form-check-input">
								<label class="form-check-label" for="chkEn">
									En Ingles
								</label>
							</div>
						</div>
					</div>
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>
import moment from 'moment';

export default {
    name: 'FormPersonalAsignacion',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
			Emit: this.poBtnSave.EmitSeccion,
			segurity:{},
			ValorCheck: 0,
			ObjCotz: {},
        }
    },
    methods :
    {
		async Guardar()
        {
			let newRequest = {
				IdCotizacion: this.ObjCotz.IdCotizacion,
				ValorCheck: this.ValorCheck,
			}

			this.$http.post('rptpdfcontrato',newRequest).then((res)=>{     
				
				let pdfWindow = window.open("");
				pdfWindow.document.write(
					"<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
					encodeURI(res.data.pdf) + "'></iframe>"
				);
			}).catch(err=>{   
				console.log(err);
			});
		},
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_seccionCliente');
        },
		Limpiar()
        {
			this.ValorCheck = 0;
		}
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id,item)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();

			this.ConfigLoad.ShowLoader = false; 
			this.ObjCotz = Id;
		});
	}
}
</script>
